import { InjectionToken } from '@angular/core';
import { SelectItem } from 'primeng/api';

export const DEFAULT_LANGUAGE = new InjectionToken<string>('DEFAULT_LANGUAGE');
export const LANGUAGE_LOCALE_OPTIONS = new InjectionToken<SelectItem[]>('LANGUAGE_LOCALE_OPTIONS');